import { render, staticRenderFns } from "./SideBarSelector.vue?vue&type=template&id=24e167c8&"
import script from "./SideBarSelector.vue?vue&type=script&lang=js&"
export * from "./SideBarSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports